// Build-time env. На dev пусто → vite.config proxy /api → http://localhost:5511.
// На prod указывается на тот же домен, где раздаётся фронт: VITE_API_URL=https://admin.your-domain.com
export const API_BASE: string = (import.meta.env.VITE_API_URL as string | undefined) ?? '';
export const TELEGRAM_BOT_USERNAME: string =
  (import.meta.env.VITE_TELEGRAM_BOT_USERNAME as string | undefined) ?? '';
